/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutrtion.reducer';

export const NutrtionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutrtionEntity = useAppSelector(state => state.nutrtion.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutrtionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutrtion.detail.title">Nutrtion</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutrtion.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.id}</dd>
          <dt>
            <span id="tmLabel">
              <Translate contentKey="tinyMedicRestApp.nutrtion.tmLabel">Tm Label</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.tmLabel}</dd>
          <dt>
            <span id="tag">
              <Translate contentKey="tinyMedicRestApp.nutrtion.tag">Tag</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.tag}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.nutrtion.description">Description</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.description}</dd>
          <dt>
            <span id="total">
              <Translate contentKey="tinyMedicRestApp.nutrtion.total">Total</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.total}</dd>
          <dt>
            <span id="rdi">
              <Translate contentKey="tinyMedicRestApp.nutrtion.rdi">Rdi</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.rdi ? 'true' : 'false'}</dd>
          <dt>
            <span id="dailyTotal">
              <Translate contentKey="tinyMedicRestApp.nutrtion.dailyTotal">Daily Total</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.dailyTotal}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="tinyMedicRestApp.nutrtion.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{nutrtionEntity.unit}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutrtion.reciepe">Reciepe</Translate>
          </dt>
          <dd>{nutrtionEntity.reciepe ? nutrtionEntity.reciepe.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nutrtion" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutrtion/${nutrtionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutrtionDetail;
